import DataTable from "pages/components/DataTable";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import UploadDocumentModel from "../Modal/UploadDocumentModel";
import { getAPIURL, sendAPIRequest } from "helpers";
import { useGetBaselineDocumentsQuery } from "modules/pvs_activities/redux/service/movements";
import { useLocation, useNavigate } from "react-router-dom";
import { empty } from "helpers";
import moment from "moment";
import { Mission_Document_type } from "modules/pvs_activities/constants";
import { MissionContext } from "../contexts/MissionTasksContext";
import { USER_ROLES } from "constants";
import { displayNotification } from "helpers";
import TextAreaField from "../core/TextAreaField";
import PopupModal from "modules/pvs_activities/components/PopupModal";

const MissionDocumentType = ({ documents, typeName, missionID, documentTypeID, documentCatagory, documentSubCatagory, userID }) => {
  const { t } = useTranslation();
  const authData = useSelector(s => s.auth.data);
  const navigate = useNavigate();
  const location = useLocation();
  const [isShow, setIsShow] = useState(false);
  const uploadModel = () => setIsShow(!isShow);
  const MissionDataContext = useContext(MissionContext);
  const authToken = useSelector((s) => s.auth.accessToken);
  const { data: baselineDocuments, isLoading } = useGetBaselineDocumentsQuery({ missionId: missionID, userId: authData.id });
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [newFilename, setNewFilename] = useState("");
  const [documentList, setDocumentList] = useState(documents);

  useEffect(() => {
    setDocumentList(documents);
  }, [documents]);

  const handleEditModalOpen = (document) => {
    setSelectedDocument(document);
    setNewFilename(document.actual_name);
    setEditModalVisible(true);
  };

  const handleEditModalClose = () => {
    setEditModalVisible(false);
    setSelectedDocument(null);
    setNewFilename("");
  };

  const handleFilenameChange = () => {
    if (selectedDocument) {
      sendAPIRequest(`/api/pvsa/mission-documents/update-filename/${selectedDocument.id}`, "PUT", {
        actual_name: newFilename,
      })
        .then(() => {
          setDocumentList((prevDocuments) =>
            prevDocuments.map((doc) =>
              doc.id === selectedDocument.id ? { ...doc, actual_name: newFilename } : doc
            )
          );
          displayNotification("success", "Successfully updated document name");
          handleEditModalClose();
        })
        .catch(() => {
          displayNotification("error", "Failed to update document name");
        });
    }
  };

  const destroy = async (id) => {
    try {
      const confirmed = window.confirm(t("243", "Are you sure you want to delete?"));
      if (!confirmed) return;

      const response = await sendAPIRequest(`/api/pvsa/mission-documents/${id}`, "DELETE");
      const result = await response.json();

      if (result.success) {
        displayNotification("success", t("-1", "Successfully deleted file"));
      } else {
        displayNotification("error", t("-1", "Failed to delete file [B]"));
      }
    } catch (error) {
      console.error("File deletion error:", error);
      displayNotification("error", t("-1", "Failed to delete file [F]"));
    }
  };


  const openLink = (movementID, dFormID, condition) => {
    const url = `/portal/pvs-activities/${condition === 'view' ? "dform-view" : "dform"}/${dFormID}/${movementID}/`;
    const currentPath = location.pathname;
    localStorage.setItem(`pvsa-process-return-url`, currentPath);
    navigate(url);
  };

  const hideCategoryColumns = {
    "Mission Correspondence": ['category_name', 'subcategory_name'],
    "Other Documents": ['mission', 'category_name', 'type_name', 'subcategory_name'],
  }

  const handleMissionLogs = () => {
    navigate(`/portal/mission-process/${missionID}/mission-logs`);
  }
  return (
    <>
      <div className="header card-woah border border-secondary d-flex btn-res1 px-4 py-2 shadow-sm w-100 my-2">
        <div className="card-title1 lh-1">{t("-1", `${typeName}`)}</div>
        <div className="header-right-items d-flex align-items-center ms-auto">
          <div className="ms-auto d-flex">
            {
              baselineDocuments && documentTypeID === 397 &&
              <button className="btn btn--primary fs-7 lh-1 ms-1" onClick={() => openLink(baselineDocuments?.id, baselineDocuments?.d_form_id, 'edit')}>
                <span className="align-middle">{t("-1", "Baseline Documents")}</span>
                <i className="fas fa-plus align-middle text-white ms-2" />
              </button>
            }
            {
              typeName === "Mission Correspondence" && (
                USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) ||
                USER_ROLES.cbd_staff.includes(parseInt(authData?.role_id)) ||
                MissionDataContext.missionManager === parseInt(authData?.id)) &&
              <div className="ms-auto">
                <button
                  onClick={() => handleMissionLogs()}
                  className="btn btn--outline fs-7 lh-1 ms-2"
                >
                  <i class="fa-solid"></i>{t("-1", "Logs")}
                </button>
              </div>
            }
            {!MissionDataContext.is_archived && (
              USER_ROLES.delegate.includes(parseInt(authData?.role_id)) ||
              MissionDataContext.missionManager === parseInt(authData?.id)) &&
              <button className="btn btn--primary fs-7 lh-1 ms-1" onClick={() => uploadModel()}>
                <span className="align-middle">{t("-1", "Upload Document")}</span>
                <i className="fas fa-plus align-middle text-white ms-2" />
              </button>}
          </div>
        </div>
      </div>

      <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
        <div className="card-body p-4">
          <DataTable
            getRowId={(row) => row.id}
            isLoading={false}
            className="text-white bg-primary rounded-0"
            rows={documentList}
            columns={[
              {
                field: "mission",
                headerName: t("22", "Country"),
                valueGetter: (params) => {
                  return params.value.country_name;
                },
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "actual_name",
                headerName: t("-1", "Document Name"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "label",
                headerName: t("-1", "Description"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "type_name",
                headerName: t("-1", "Document Type"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 100,
                flex: 1,
              },
              {
                field: "category_name",
                headerName: t("-1", "Document Category"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 100,
                flex: 1,
              },
              {
                field: "subcategory_name",
                headerName: t("-1", "Document SubCategory"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 100,
                flex: 1,
              },
              {
                field: "createdAt",
                headerName: t("-1", "Timestamp"),
                valueGetter: ({ value }) => (!empty(value) ? value : null),
                valueFormatter: ({ value }) =>
                  !empty(value)
                    ? moment(value).format("DD-MMMM-YYYY (hh:mm A)")
                    : "",
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 100,
                flex: 1,
              },
              {
                field: "actions",
                type: "actions",
                headerClassName: "text-white bg-primary rounded-0",
                headerName: t("-1", "Actions"),
                getActions: (params) => {
                  const actions = [];
                  actions.push(
                    <GridActionsCellItem
                      label={"Download Document"}
                      key={`downloadform-${params.row?.id}`}
                      showInMenu
                      onClick={() =>
                        window.open(
                          getAPIURL(
                            `/api/pvsa/mission-documents/download/${params.row?.id}?_token=${authToken}`,
                            "_target"
                          )
                        )
                      }
                    />
                  );
                  if (!MissionDataContext.is_archived) {
                    actions.push(
                      <GridActionsCellItem
                        label={"Edit"}
                        key={`Edit-${params.row?.id}`}
                        showInMenu
                        onClick={() => handleEditModalOpen(params.row)}
                      />
                    );
                  }
                  if (USER_ROLES.business_admin.includes(parseInt(authData.role_id)) || parseInt(authData.role_id) === parseInt(MissionDataContext?.missionManager)) {
                    actions.push(
                      <GridActionsCellItem
                        showInMenu
                        label={t("-1", "Delete Document")}
                        key={2}
                        onClick={() => destroy(params.row.id)}
                      />
                    );
                  }
                  return actions;
                },
              },
            ].filter(({ field }) =>
              hideCategoryColumns[typeName] ? !hideCategoryColumns[typeName].includes(field) : true
            )}
          />
        </div>
      </div>
      {
        isShow &&
        <UploadDocumentModel
          isShow={isShow}
          uploadModel={uploadModel}
          typeName={typeName}
          missionID={missionID}
          showCategoriesFilters={true}
          documentTypeID={documentTypeID}
          documentCatagory={documentCatagory}
          documentSubCatagory={documentSubCatagory}
          userID={userID}
        />
      }
      <PopupModal
        title={t("-1", "Edit Filename")}
        size="md"
        defaultShow={isEditModalVisible}
        onClose={handleEditModalClose}
        triggers={({ openModal }) => null}
        footTriggers={({ closeModal }) => (
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn--outline fs-7 lh-1 my-auto mt-1 me-1"
              onClick={closeModal}
            >
              {t("-1", "Cancel")}
            </button>
            <button
              type="button"
              className="btn btn--primary fs-7 lh-1 my-auto mt-1 me-1"
              onClick={handleFilenameChange}
            >
              {t("-1", "Save Changes")}
            </button>
          </div>
        )}
      >
        <div className="col-md-12">
          <TextAreaField
            label={t("-1", "Filename")}
            required
            fullWidth
            value={newFilename}
            onChange={(value) => setNewFilename(value)}
            size="small"
            sx={{
              marginTop: "6px",
              marginBottom: "6px",
              backgroundColor: "white",
            }}
          />
        </div>
      </PopupModal>
    </>
  );
};

MissionDocumentType.defaultProps = {
  missionID: "",
  data: [],
  typeName: "",
  documentTypeID: "",
  userID: "",
};

export default MissionDocumentType;
